<nz-modal 
    [(nzVisible)]="visible" 
    nzTitle="Close Breakdown" 
    (nzOnCancel)="onCancel()" 
    (nzOnOk)="onConfirmCloseIncident()"
    nzOkText="Close Breakdown"
    nzCancelText="Cancel"
    [nzOkLoading]="isLoading"
    nzWidth="600px">
    <ng-container *nzModalContent>
        <form nz-form>
            <nz-form-item>
                <nz-form-label [nzSpan]="8" nzFor="closeOrderNumber">Order Number</nz-form-label>
                <nz-form-control [nzSpan]="16">
                    <input nz-input placeholder="Enter order number" id="closeOrderNumber" name="closeOrderNumber" type="text" [(ngModel)]="closeRequest.orderNumber" />
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label [nzSpan]="8" nzFor="closeDateCompleted" nzRequired>Date Completed</nz-form-label>
                <nz-form-control [nzSpan]="16">
                    <nz-space>
                        <nz-date-picker *nzSpaceItem id="closeDateCompleted" name="closeDateCompleted" [(ngModel)]="closeRequest.dateCompleted" nzFormat="yyyy-MM-dd" style="width: 180px;"></nz-date-picker>
                        <nz-time-picker *nzSpaceItem id="closeTimeCompleted" name="closeTimeCompleted" [(ngModel)]="closeRequest.dateCompleted" nzFormat="HH:mm" style="width: 120px;"></nz-time-picker>
                    </nz-space>
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label [nzSpan]="8" nzFor="closeWorkDone" nzRequired>Work Done</nz-form-label>
                <nz-form-control [nzSpan]="16">
                    <input nz-input placeholder="Select or type work done" id="closeWorkDone" [(ngModel)]="closeRequest.workDone" name="closeWorkDone" [nzAutocomplete]="workDoneAuto" />
                    <nz-autocomplete #workDoneAuto>
                        @for (option of sharedDataService.workDoneTypes; track option.id) {
                            <nz-auto-option [nzValue]="option.value">{{ option.value }}</nz-auto-option>
                        }
                    </nz-autocomplete>
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label [nzSpan]="8" nzFor="closeComment">Comments</nz-form-label>
                <nz-form-control [nzSpan]="16">
                    <textarea nz-input placeholder="Additional comments" id="closeComment" name="closeComment" [(ngModel)]="closeRequest.comment" [nzAutosize]="{ minRows: 2, maxRows: 4 }"></textarea>
                </nz-form-control>
            </nz-form-item>
        </form>
    </ng-container>
</nz-modal>
